export const environment = {
    production: false,
    apiURL: 'https://apistaging.alhusnainmotors.co.ke/api',
    tokenURL: 'https://apistaging.alhusnainmotors.co.ke'
};
